import { render, staticRenderFns } from "./Icap.vue?vue&type=template&id=13f90d26&lang=true"
import script from "./Icap.vue?vue&type=script&lang=js"
export * from "./Icap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports